<template>
    <div class="custom-date-range-type-1">
        <CustomSelect
            :modelValue="modelValue?.custom || 'all'"
            :inputKey="inputKey"
            @update:modelValue="onSelectChanged"
            :options="optionsTimePeriod"
            :showLabel="false"
            :showDescription="false"
        />

        <div v-if="modelValue?.custom === 'custom'" class="form-type-0">
            <div class="calendar-container" v-if="showCalendar">
                <DatePicker
                    v-if="showCalendar"
                    v-model.range="dateRange"
                    :max-date="new Date()"
                    :columns="1"
                    :masks="{ input: 'DD-MM-YYYY' }"
                    :locale="$i18n.locale"
                    is-expanded
                    borderless
                    @update:modelValue="onDateRangeChanged"
                />

                <div v-if="!!modelValue.min || !!modelValue.max" @click="showCalendar = false" class="btn-6 btn-s-icon close-button">
                    <div class="icon-close-neg"></div>
                </div>
            </div>

            <div class="date-display" @click="showCalendar = !showCalendar" v-if="!showCalendar" style="cursor: pointer;">
                <CustomInput
                    inputKey="default.time_period_min"
                    :modelValue="modelValue?.min ? timestampToDisplayDate(modelValue.min, false, true) : ''"
                    :disabled="false"
                    :showDescription="false"
                />
                <CustomInput
                    inputKey="default.time_period_max"
                    :modelValue="modelValue?.max ? timestampToDisplayDate(modelValue.max, false, true) : ''"
                    :disabled="false"
                    :showDescription="false"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { DatePicker } from 'v-calendar';
    import 'v-calendar/style.css';
    import CustomSelect from '@/components/inputs/CustomSelect';
    import CustomInput from '@/components/inputs/CustomInput';
    import { timestampToDisplayDate } from '@/utils/dates';

    export default {
        name: "CustomSelectDateRange",
        components: {
            CustomSelect,
            CustomInput,
            DatePicker
        },
        props: {
            modelValue: {
                type: Object,
                default: () => ({ min: null, max: null, custom: 'custom' })
            },
            inputKey: {
                type: String,
                default: 'default.time_periods'
            },
            includeAllOption: {
                type: Boolean,
                default: false
            },
            optionsType: {
                type: String,
                default: 'short'
            }
        },
        data() {
            return {
                showCalendar: false,
                optionsTimePeriod: [
                    ...(this.includeAllOption ? [{ value: 'all', text: 'fields.default.time_periods.all' }] : []),
                    { value: 'custom', text: 'fields.default.time_periods.custom' },
                    ...(this.optionsType === 'long' ? [
                        { value: 'today', text: 'fields.default.time_periods.today' },
                        { value: 'yesterday', text: 'fields.default.time_periods.yesterday' },
                        { value: 'd_7', text: 'fields.default.time_periods.d_7' },
                        { value: 'd_30', text: 'fields.default.time_periods.d_30' },
                        { value: 'd_90', text: 'fields.default.time_periods.d_90' },
                    ] : []),
                    { value: 'm_current', text: 'fields.default.time_periods.m_current' },
                    { value: 'm_last', text: 'fields.default.time_periods.m_last' },
                    { value: 'y_current', text: 'fields.default.time_periods.y_current' },
                    { value: 'y_last', text: 'fields.default.time_periods.y_last' }
                ]
            }
        },
        computed: {
            dateRange: {
                get() {
                    if (!this.modelValue?.min && !this.modelValue?.max) {
                        return null;
                    }
                    return {
                        start: this.modelValue?.min ? new Date(this.modelValue.min * 1000) : null,
                        end: this.modelValue?.max ? new Date(this.modelValue.max * 1000) : null
                    };
                },
                set() {
                    // Handled by onDateRangeChanged
                }
            }
        },
        methods: {
            timestampToDisplayDate,
            onSelectChanged(newValue) {
                const updated = { ...this.modelValue, custom: newValue };
                if (newValue !== 'custom') {
                    updated.min = null;
                    updated.max = null;
                } else {
                    this.initCalendar();
                }
                this.$emit('update:modelValue', updated);
                
            },
            initCalendar() {
                if(this.modelValue.custom !== 'custom') {
                    return;
                } else if (!this.modelValue.min && !this.modelValue.max) {
                    this.showCalendar = true;
                } else {
                    this.showCalendar = false;
                }
            },
            onDateRangeChanged(range) {
                if (!range || (!range.start && !range.end)) {
                    const updated = { ...this.modelValue };
                    updated.min = null;
                    updated.max = null;
                    this.$emit('update:modelValue', updated);
                    return;
                }
                
                const updated = { ...this.modelValue };
                
                if (range.start) {
                    const startDate = new Date(range.start);
                    startDate.setHours(0, 0, 0, 0);
                    updated.min = Math.floor(startDate.getTime() / 1000);
                } else {
                    updated.min = null;
                }
                
                if (range.end) {
                    const endDate = new Date(range.end);
                    endDate.setHours(23, 59, 59, 999);
                    updated.max = Math.floor(endDate.getTime() / 1000);
                } else {
                    updated.max = null;
                }
                
                this.$emit('update:modelValue', updated);
                this.showCalendar = false;
            }
        },
        watch: {
            modelValue(newVal) {
                if (newVal?.custom === 'custom') {
                    this.initCalendar();
                }
            }
        },
        mounted() {
            this.initCalendar();
        }
    }
</script>